import { ajax } from "../../../../../plugins/api";

export const reason = {
    all: ({ id, page }) => ajax.get(`bans/reasons/paginate/${id}?page=${page}`),
    get: id => ajax.get(`bans/reasons/${id}?include=template`),
    update: (id, data, vmId = null, scope = "form") =>
        ajax.put(`bans/reasons/${id}?include=template`, data, vmId, scope),
    store: (data, vmId = null, scope = "form") => ajax.post("bans/reasons?include=template", data, vmId, scope),
    destroy: id => ajax.delete(`bans/reasons/${id}`),
    list: id => ajax.get(`bans/reasons/${id}?include=template`)
};
